import React from 'react';

import ContentfulImage from '../ContentfulImage';
import RichTextConverter from '../RichText/RichTextConverter';
import * as styles from './SideScroll.module.scss';

export default function OverlappingBleed({ content, contentRef }) {
  /*style={{ '--bg-image': `url('${card.image?.file?.url}')` }}*/
  return (
    <div className={[styles.overlappingBleed].join(' ')} ref={contentRef}>
      {content.map((card, i) => (
        <div
          key={i}
          className={styles.content}
          data-analytics-id={card.title}
          data-analytics-component={'overlapping-bleed-card'}
        >
          <ContentfulImage lazy={true} className={styles.backgroundImage} imageFragment={card.image} />
          <div className={styles.copy}>
            <h3 className={styles.title}>{card.title}</h3>
            <RichTextConverter copy={card.body} />
          </div>
        </div>
      ))}
    </div>
  );
}
